import { useQuery } from '@tanstack/react-query';
import { messagingService } from 'v2/services/messaging';

export const useChatProducts = () => {
  const { data, isLoading, isFetching, error, refetch } = useQuery<{ data: { id: number; name: string }[] }>({
    queryKey: ['messages', 'products'],
    queryFn: () => messagingService.listProducts()
  });

  return {
    products: data?.data || [],
    isLoading,
    isFetching,
    error,
    refetch
  };
};
